function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m0.51086 20.058c0-10.76 8.7354-19.495 19.495-19.495 10.797 0 19.495 8.7354 19.495 19.495 0 10.797-8.698 19.495-19.495 19.495-10.76 0-19.495-8.698-19.495-19.495z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m3.4648 18.637h24v19.494l-3.3249 1.0381c-1.2994 0.26914-2.637 0.38449-4.0128 0.38449-6.8791 0-12.917-3.4604-16.51-8.7663l-0.15287-0.23069z",
  fill: "#adb9ca"
}), React.createElement("path", {
  d: "m6.8094 25.082c0-0.26244 0.26244-0.52488 0.52488-0.52488h16.796c0.29993 0 0.52488 0.26244 0.52488 0.52488v2.0995c0 0.29993-0.22495 0.52488-0.52488 0.52488h-16.796c-0.26244 0-0.52488-0.22495-0.52488-0.52488z",
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m6.4256 25.017c0-0.26244 0.26617-0.52488 0.53233-0.52488h17.035c0.30419 0 0.53233 0.26244 0.53233 0.52488v2.0995c0 0.29993-0.22814 0.52488-0.53233 0.52488h-17.035c-0.26617 0-0.53233-0.22495-0.53233-0.52488z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4.8,
  strokeWidth: 1.0071
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m11.458 30.368c0-0.22495 0.18746-0.4124 0.4124-0.4124h12.41c0.22495 0 0.37491 0.18746 0.37491 0.4124v1.6121c0 0.22495-0.14996 0.37491-0.37491 0.37491h-12.41c-0.22495 0-0.4124-0.14996-0.4124-0.37491z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m11.409 30.821c0-0.19405 0.18609-0.35576 0.4094-0.35576h12.319c0.22331 0 0.37218 0.16171 0.37218 0.35576v1.3907c0 0.19405-0.14887 0.32341-0.37218 0.32341h-12.319c-0.22331 0-0.4094-0.12937-0.4094-0.32341z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4.8
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m6.3536 31.351c0-0.63735 0.52488-1.1997 1.1247-1.1997 0.63735 0 1.1247 0.56237 1.1247 1.1997 0 0.67484-0.48739 1.1997-1.1247 1.1997-0.59986 0-1.1247-0.52488-1.1247-1.1997z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m6.4902 31.481c0-0.53017 0.4915-0.99797 1.0532-0.99797 0.59682 0 1.0532 0.4678 1.0532 0.99797 0 0.56136-0.4564 0.99797-1.0532 0.99797-0.56172 0-1.0532-0.43661-1.0532-0.99797",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4.8,
  strokeWidth: 0.88258
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m11.458 34.867c0-0.22495 0.18746-0.4124 0.4124-0.4124h12.41c0.22495 0 0.37491 0.18746 0.37491 0.4124v1.6121c0 0.22495-0.14996 0.37491-0.37491 0.37491h-12.41c-0.22495 0-0.4124-0.14996-0.4124-0.37491z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m11.424 34.908c0-0.19469 0.18564-0.35694 0.40842-0.35694h12.29c0.22278 0 0.37129 0.16224 0.37129 0.35694v1.3953c0 0.19469-0.14852 0.32449-0.37129 0.32449h-12.29c-0.22278 0-0.40842-0.1298-0.40842-0.32449z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4.8,
  strokeWidth: 0.97621
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m3.5529 30.522-0.15322-0.22495v-11.66h24.055v19.046",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 4.8,
  strokeWidth: 1.0108
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m14.533 26.281 0.4124-5.2863c-6.0361-2.5869-7.8357-7.9481-4.049-11.997 3.8241-4.0865 11.772-5.2863 17.808-2.7369 6.0361 2.5869 7.8357 7.9481 4.0116 11.997-2.7743 2.9993-8.0231 4.5739-13.197 3.9366z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m14.533 26.281 0.4124-5.2863c-6.0361-2.5869-7.8357-7.9481-4.049-11.997 3.8241-4.0865 11.772-5.2863 17.808-2.7369 6.0361 2.5869 7.8357 7.9481 4.0116 11.997-2.7743 2.9993-8.0231 4.5739-13.197 3.9366z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m12.463 13.554c0-1.0872 0.93728-2.0245 2.0245-2.0245 1.1247 0 2.0245 0.93728 2.0245 2.0245 0 1.1247-0.89979 2.0245-2.0245 2.0245-1.0872 0-2.0245-0.89979-2.0245-2.0245z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.528 13.489c0-1.0872 0.93728-2.0245 2.0245-2.0245 1.1247 0 2.0245 0.93728 2.0245 2.0245 0 1.1247-0.89979 2.0245-2.0245 2.0245-1.0872 0-2.0245-0.89979-2.0245-2.0245",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m19.446 13.554c0-1.0872 0.97477-2.0245 2.0995-2.0245 1.1622 0 2.0995 0.93728 2.0995 2.0245 0 1.1247-0.93728 2.0245-2.0995 2.0245-1.1247 0-2.0995-0.89979-2.0995-2.0245z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m19.446 13.554c0-1.0872 0.97477-2.0245 2.0995-2.0245 1.1622 0 2.0995 0.93728 2.0995 2.0245 0 1.1247-0.93728 2.0245-2.0995 2.0245-1.1247 0-2.0995-0.89979-2.0995-2.0245",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m26.514 13.489c0-1.0872 0.93728-2.0245 2.0245-2.0245 1.1247 0 2.0245 0.93728 2.0245 2.0245 0 1.1247-0.89979 2.0245-2.0245 2.0245-1.0872 0-2.0245-0.89979-2.0245-2.0245z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m26.579 13.554c0-1.0872 0.93728-2.0245 2.0245-2.0245 1.1247 0 2.0245 0.93728 2.0245 2.0245 0 1.1247-0.89979 2.0245-2.0245 2.0245-1.0872 0-2.0245-0.89979-2.0245-2.0245",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.51086 20.058c0-10.76 8.7354-19.495 19.495-19.495 10.797 0 19.495 8.7354 19.495 19.495 0 10.797-8.698 19.495-19.495 19.495-10.76 0-19.495-8.698-19.495-19.495",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var SvgDefineSurveyTabComms = function SvgDefineSurveyTabComms(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDefineSurveyTabComms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Define-Survey-Tab-Comms.36dd40b6.svg";
export { ForwardRef as ReactComponent };